import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=a6b37416&scoped=true&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"
import style0 from "../assets/scss/variables.scss?vue&type=style&index=0&id=a6b37416&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b37416",
  null
  
)

export default component.exports